<template>
  <div id="retrospect" style="margin-top: 67px;overflow: hidden;">
    <div class="focuImg" ref="element">

      <div id="bannerimg" class="swiper-container bjh bannerimg">
        <img style="width: 100%;" src="/static/img/img_banner3.png" alt="重要产品追溯" />
      </div>
    </div>
    <div v-if="navBarFixed == true" style="height: 68px;"></div>
    <ul class="TopNav" :class="navBarFixed == true ? 'navBarWrap' :''">
      <li :class="TopNav==1?'active':''" @click="goAnchor('#a')">
        方案介绍
      </li>
      <li :class="TopNav==2?'active':''" @click="goAnchor('#b')">
        解决方案
      </li>
      <li :class="TopNav==3?'active':''" @click="goAnchor('#c')">
        方案特点
      </li>
      <li :class="TopNav==4?'active':''" @click="goAnchor('#d')">
        优质服务
      </li>
      <li :class="TopNav==5?'active':''" @click="goAnchor('#e')">
        城市合伙人招募
      </li>

    </ul>
    <a class="content2 content1 flexY" ref="a">
      <div class="mddw" id="a"></div>
      <div style="margin-top: 80px;">
        <div class="gnld">
          <p class="biaoti" style="margin-bottom: 100px;">方案介绍</p>
          <div class="body1">
            <div class="both">
              <div class="radius">
                <img src="../../static/img/icon_schemeintroduction_1.png" class="img1" />

              </div>
              <p class="font2">以食品安全溯源为核心</p>
              <p class="font1">依托多年积累 “科技+数据+服务+生态” 综合优势，实现来源可追溯，去向可查证，责任可追究</p>
            </div>
            <div class="both">
              <div class="radius">
                <img src="../../static/img/icon_schemeintroduction_2.png" class="img1" />

              </div>
              <p class="font2">智慧食安监管+公众服务</p>
              <p class="font1">打造一体化平台，解决食品企业生产质量控制风险问题</p>
            </div>
            <div class="both">
              <div class="radius">
                <img src="../../static/img/icon_schemeintroduction_3.png" class="img1" />

              </div>
              <p class="font2">社会共治共享</p>
              <p class="font1">树立企业品牌形象，全面助力提升食品安全社会共治共享水平</p>
            </div>

          </div>

        </div>
      </div>

    </a>
    <a class="content2 flexY content1 bjh zuhe" ref="b">
      <div class="mddw" id="b"></div>
      <div class="background1">
        <p class="fanan">解决方案</p>
        <ul class="buju">
          <li :class="light==1?'light1':''" @click="change(1)">智能监管</li>
          <li :class="light==2?'light1':''" @click="change(2)">企业自律</li>
          <li :class="light==3?'light1':''" @click="change(3)">社会共治</li>
        </ul>

        <div v-show="light==1">
          <div class="honourBanner swiper-container" id="honourBanner">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <div>
                  <p class="font3">PC端+移动端联合监管</p>
                  <img src="../../static/img/solution_img_intelligentsupervision_1.png" class="img2" />
                </div>
              </div>
              <div class="swiper-slide">
                <div>
                  <p class="font3">多平台,多维度数据对比分析，呈现更直观</p>
                  <img src="../../static/img/solution_img_intelligentsupervision_2.png" class="img2"
                    style="margin-top: 38px;" />
                </div>
              </div>
            </div>
            <div class="swiper-button-next" @click="add(light)"></div>
            <div class="swiper-button-prev" @click="lose(light)"></div>
          </div>
          <div class="number1">{{number1}}/2</div>
        </div>

        <div v-show="light==2">
          <div class="honourBanner1 swiper-container" id="honourBanner1">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <div>
                  <p class="font4">一企一档一码诚信经营档案，索证索票溯源数据关联，智慧食品安全管理无忧</p>
                  <img src="../../static/img/lALPD4Bhs5gnC9rNAbnNA7s_955_441.png" class="img3"
                    style="margin-top: 37px;" />
                </div>
              </div>
              <div class="swiper-slide">
                <div>
                  <p class="font4">通过物联网设备,对重要监管环节取证，实时查看所有安全信息，对现场一目了然，做到可视，可控</p>
                  <img src="../../static/img/solution_img_enterpriseselfdiscipline_2.png" class="img2"
                    style="margin-top: 84px;" />
                </div>
              </div>
            </div>
            <div class="swiper-button-next" @click="add(light)"></div>
            <div class="swiper-button-prev" @click="lose(light)"></div>
          </div>
          <div class="number1">{{number2}}/2</div>
        </div>

        <div v-if="light==3">
          <div class="honourBanner2 swiper-container" id="honourBanner2">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <div>
                  <p class="font4">观看后厨加工视频直播，做到数字可视化一目预览。主动征集群众关心的食品安全问题，并有效解决，及时反馈，让群众满意</p>
                  <img src="../../static/img/solution_img_socialcogovernance_1.png" class="img3"
                    style="margin-top: 84px;">
                </div>
              </div>
              <div class="swiper-slide">
                <div>
                  <p class="font4">追溯查询平台在餐饮企业日常运营和公众监督间开辟一条数字通道，社会公众可确保食材从采购到制作安全，可靠</p>
                  <img src="../../static/img/lALPD3zUNOeeljjNAUvNA24_878_331.png" class="img2" />
                </div>
              </div>
            </div>
            <div class="swiper-button-next" @click="add(light)"></div>
            <div class="swiper-button-prev" @click="lose(light)"></div>

          </div>
          <div class="number1">{{number3}}/2</div>
        </div>
      </div>

    </a>

   <a class="content2 content1 yyhy" style="" ref="c">
      <div class="mddw" id="c"></div>
      <div class="quan">
        <img src="/static/img/img_Internet+regulation.png" class="imgw" />
        <div class="weizi1">
          <h1 class="font5">互联网+监管</h1>
          <p class="font6">基于丰富的，动态的，公正的数据大数据支撑，落实监管责任</p>
        </div>
        <div class="weizi2">
          <h1 class="font5" style="margin-left: 46px;">自改自查</h1>
          <p class="font6">通过自学，自查，自改，信用监督实现阳光治理</p>
        </div>
        <img src="/static/img/img_selfimprovementandselfinspection.png" class="imgz" />
      </div>
    </a>


    <a class="content1 dzfa" ref="d" style="">
      <div class="mddw" id="d"></div>
      <table></table>
      <p class="biaoti" style="margin-top: 73px;">相关产品</p>
      <div class="buju1">
        <div class="tool">
          <img src="../../static/img/lALPD2eDPSHO-EnNAR7NAVQ_340_286.png" class="img4" />
          <p class="p4">智能溯源秤</p>
        </div>
        <div class="tool">
          <img src="../../static/img/img_relatedproducts_2.png" class="img4" />
          <p class="p4">手机端APP</p>
        </div>
        <div class="tool">
          <img src="../../static/img/img_relatedproducts_3.png" class="img4" />
          <p class="p4">大数据</p>
        </div>
      </div>
    </a>
    <div>
      <img src="../../static/img/img_goodservice.png" style="width: 100%;" />
    </div>
    <a class="content2  content1 shyy" style="" ref="e">
      <div class="mddw" id="e"></div>

      <p class="biaoti" style="padding-top: 120px;margin-bottom: 90px;font-weight: 400;color:#000201;">360°全方位服务体系</p>
      <div class="flex gnld4con" style="width: 990px;">
        <div class="gnld4item" v-for="(item,index) in list3" :key="index">
          <img :src="item.src" />
          <div class="gnld4name">{{item.name}}</div>
          <div class="gnld4con" v-html="item.con"></div>
        </div>
      </div>
    </a>
    <div>
      <img style="width: 100%;" src="../../static/img/img_cshhr.png" />
    </div>

    <div class="footerbox" ref="f">
      <div class="mddw" id="f"></div>
      <div class="footerboxTop">
        <div class="list1">
          <p class="p1">联系我们</p>
          <div class="xian"></div>
          <p class="p2">服务热线</p>
          <p class="p3">0571-87357305</p>
          <p class="p2">公司邮箱</p>
          <p class="p3">zjax@ansuw.com</p>
        </div>
        <div class="list2">
          <p class="p1">产品服务</p>
          <div class="xian"></div>
          <p class="p1" style="line-height: 45px;margin: 0;">软件产品</p>
          <div style="display: flex;flex-wrap: wrap;">
            <a href="http://www.ax168.com/system?activeIndex=0">食品追溯系统</a>
            <a href="http://www.ax168.com/system?activeIndex=1">食品检测系统</a>
            <a href="http://www.ax168.com/system?activeIndex=2">市场运营系统</a>
            <a href="http://www.ax168.com/system?activeIndex=3">商家管理系统</a>
            <a href="http://www.ax168.com/system?activeIndex=4">会员营销系统</a>
            <a href="http://www.ax168.com/system?activeIndex=5">网上菜场系统</a>
            <a href="http://www.ax168.com/system?activeIndex=6">市场招商系统</a>
            <a href="http://www.ax168.com/system?activeIndex=7">电子结算系统</a>
            <a href="http://www.ax168.com/system?activeIndex=8">智能巡查系统</a>
            <a href="http://www.ax168.com/system?activeIndex=9">数据展示系统</a>
            <a href="http://www.ax168.com/system?activeIndex=10">智慧农场系统</a>
            <a href="http://www.ax168.com/system?activeIndex=11">智慧禽畜系统</a>
            <a href="http://www.ax168.com/system?activeIndex=12">智慧水产系统</a>
          </div>
          <p class="p1" style="line-height: 45px;margin: 0;">硬件产品</p>
          <div style="display: flex;flex-wrap: wrap;">
            <a>智慧农贸追溯电子秤</a>
            <a>商户信用公示屏</a>
            <a>放心农贸触摸一体机</a>
            <a>数据大屏</a>
          </div>
        </div>
        <div class="list3">
          <p class="p1">关于我们</p>
          <div class="xian"></div>
          <p class="p2">
            <a href="http://www.ax168.com/about/#a">企业简介</a>
          </p>
          <p class="p2">
            <a href="http://www.ax168.com/about/#b">企业优势</a>
          </p>
          <p class="p2">
            <a href="http://www.ax168.com/about/#c">资质荣誉</a>
          </p>
          <p class="p2">
            <a href="http://www.ax168.com/about/#d">企业特色</a>
          </p>
        </div>
      </div>
      <div class="footerboxC">
        <div class="xian"></div>
        <div class="textList">
          <p>解决方案</p>
          <p>
            <a href="http://www.ax168.com/publicity">智慧农贸解决方案</a>
          </p>
          <p>
            <a href="http://www.ax168.com/ygst">阳光厨房解决方案</a>
          </p>
          <p>
            <a href="http://www.ax168.com/zycpzs">重要产品追溯解决方案</a>
          </p>
        </div>
        <div class="xian"></div>
      </div>
      <div class="footerboxb">
        <p>地址： 浙江省杭州市西湖区西园八路11号一期D座506-507</p>
        <p style="cursor: pointer" @click="handNavGx">{{ICP_text}}</p>
        <p>公安部备案号：33010602001517</p>
      </div>
    </div>
  </div>
</template>

<script>
  import Swiper from 'swiper'
  import 'swiper/dist/css/swiper.min.css'
  export default {
    data() {
      return {
        navBarFixed: false,
        gengduo: false,
        TopNav: 1,
        light: 1,
        list: [],
        number1: 1,
        number2: 1,
        number3: 1,
        list3: [{
          name: '专业客服支持',
          con: "一对一客服全程</br>在线服务",
          src: '/static/img/fwtx_icon_1.png'
        }, {
          name: '强大代运营服务',
          con: "优秀运营团队</br>提供可靠的运营服务",
          src: '/static/img/fwtx_icon_2.png'
        }, {
          name: '大数据分析',
          con: "专项领域的高超技术支持</br>在垂直市场获得领先优势",
          src: '/static/img/fwtx_icon_3.png'
        }, ],
         ICP_text:'浙ICP备15019864号-1',
      ICP:{
        "http://localhost:8081":"测试",
        "http://www.ax168.com":"浙ICP备15019864号-4",
        "http://www.anxuan360.com":"浙ICP备15019864号-1",
        "http://www.axnm168.com":"浙ICP备15019864号-5",
        "http://www.aswnm.com":"浙ICP备15019864号-7",
        "http://www.axny168.com":"浙ICP备15019864号-6"
      },

      }

    },

    created: function() {
        let keys = Object.keys(this.ICP)
    let findIndex=  keys.findIndex(key=>{
       return  key.includes(window.location.host)
    })
    this.ICP_text =findIndex!=-1? this.ICP[keys[findIndex]]:this.ICP_text
      this.$emit('footer', false);
      this.$emit('footer1', false);
      this.$emit('footer2', true);

    },
    activated() {
      //			document.title = "安宣智慧农贸-智慧农贸方案-安宣农贸解决方案"
      document.documentElement.style.fontSize = document.documentElement.clientWidth / 7.5 + 'px';
//    var swiper1 = new Swiper('#honourBanner', {
//      paginationClickable: true,
//      nextButton: '#honourBanner .swiper-button-next',
//      prevButton: '#honourBanner .swiper-button-prev',
//      parallax: true,
//      speed: 500,
//      loop: true,
//    });




      // var swiper3 = new Swiper('#honourBanner2', {
      //   paginationClickable: true,
      //   nextButton: '#honourBanner2 .swiper-button-next',
      //   prevButton: '#honourBanner2 .swiper-button-prev',
      //   parallax: true,
      //   speed: 600,
      // });

    },

    methods: {
  handNavGx(){
        window.open("https://beian.miit.gov.cn", '_blank')
      },
      goAnchor(selector) {
        this.$el.querySelector(selector).scrollIntoView({
          behavior: "smooth", // 平滑过渡
          block: "start" // 上边框与视窗顶部平齐。默认值
        });
      },
      watchScroll() {
        var scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop;
        // console.log( this.$refs.a.offsetTop)
        if ( typeof this.$refs.a.offsetTop !== "undefined") {
          let a = this.$refs.a.offsetTop
          if (scrollTop + 70 >= a) {
            this.TopNav = 1
          }


        }
        if (typeof this.$refs.b.offsetTop !== "undefined") {
          let b = this.$refs.b.offsetTop
          if (scrollTop + 70 >= b) {
            this.TopNav = 2
            //									this.getData();
          }

        }
        if ( typeof this.$refs.c.offsetTop !== "undefined") {
          let c = this.$refs.c.offsetTop
          if (scrollTop + 70 >= c) {
            this.TopNav = 3
          }

        }
        if ( typeof this.$refs.d.offsetTop !== "undefined") {
          let d = this.$refs.d.offsetTop
          if (scrollTop + 70 >= d) {
            this.TopNav = 4
          }

        }
        if ( typeof this.$refs.e.offsetTop !== "undefined") {
          let e = this.$refs.e.offsetTop
          if (scrollTop + 250 >= e) {
            this.TopNav = 5
          }
        }


        let height = this.$refs.element.offsetHeight
        //  当滚动超过 90 时，实现吸顶效果
        if (scrollTop > height) {
          this.navBarFixed = true;
        } else {
          this.navBarFixed = false;
        }

      },
      change(number) {
        this.light = number;

        this.$nextTick(() => {

        	 if (number == 1) {
            var swiper = new Swiper('#honourBanner', {
              paginationClickable: true,
              nextButton: '#honourBanner .swiper-button-next',
              prevButton: '#honourBanner .swiper-button-prev',
              parallax: true,
              speed: 500,
              loop: true,
            });

          }

          if (number == 2) {
            var swiper2 = new Swiper('#honourBanner1', {
              paginationClickable: true,
              nextButton: '#honourBanner1 .swiper-button-next',
              prevButton: '#honourBanner1 .swiper-button-prev',
              parallax: true,
              speed: 500,
              loop: true,
            });

          }
          if (number == 3) {
            var swiper3 = new Swiper('#honourBanner2', {
              paginationClickable: true,
              nextButton: '#honourBanner2 .swiper-button-next',
              prevButton: '#honourBanner2 .swiper-button-prev',
              parallax: true,
              speed: 500,
              loop: true,
            });

          }
        })


      },
      lose(light) {
        if (light == 1 && this.number1 > 1) {
          this.number1 = this.number1 - 1;

        } else if (light == 1 && this.number1 < 1) {
          this.number1 = this.number1 + 1
        } else if (light == 2 && this.number2 > 1) {
          this.number2 = this.number2 - 1;
        } else if (light == 2 && this.number2 < 1) {
          this.number2 = this.number2 + 1
        } else if (light == 3 && this.number3 > 1) {
          this.number3 = this.number3 - 1;
        } else if (light == 3 && this.number3 < 1) {
          this.number3 = this.number3 + 1
        }
      },
      add(light) {
        if (light == 1 && this.number1 < 2) {
          this.number1 = this.number1 + 1;
        } else if (light == 1 && this.number1 >= 2) {
          this.number1 = this.number1 - 1
        } else if (light == 2 && this.number2 < 2) {
          this.number2 = this.number2 + 1;
        } else if (light == 2 && this.number2 >= 2) {
          this.number2 = this.number2 - 1
        } else if (light == 3 && this.number3 < 2) {
          this.number3 = this.number3 + 1;
        } else if (light == 3 && this.number3 >= 2) {
          this.number3 = this.number3 - 1
        }

      }



    },

    mounted() {

      //		var swiper = new Swiper('.swiper-container', {
      //				slidesPerView: 'auto',
      //				pagination: '.swiper-pagination',
      //			});
      window.addEventListener("scroll", this.watchScroll);
      var th = this
      window.onresize = function() { //监听屏幕的改变
        document.documentElement.style.fontSize = document.documentElement.clientWidth / 7.5 + 'px';
      };
      	this.change(1)
    },
    components: {

    },


  }
</script>
<style scoped="scoped">
  @import url('../css/retrospect.css');
  @import url('../css/home.css');

  [v-cloak] {
    display: none !important;
  }

  #home_dataShow {
    box-shadow: 0px 0px 0px rgba(0, 0, 0, 0);
  }

  .imgclass {
    margin: 20px;
    padding-right: 15px;
    border-right: 1px solid #000000;
    display: inline-block;
  }

  .header {
    font-size: 14px;
    position: relative;
    font-weight: 400;
  }

  .flex {
    display: flex;
  }


  .gnld4item img {
    margin: 0 auto;
  }

  .gnld4item:nth-child(3) .gnld4name:nth-child(2) {
    margin-top: 37px;
  }

  .gnld4name {
    height: 23px;
    font-size: 22px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #202020;
    line-height: 32px;
    margin-bottom: 10px;
    text-align: center;
    line-height: 23px;
    margin-top: 40px;
  }

  .gnld4item:nth-child(3) .gnld4name:nth-child(2) {
    margin-top: 30px;
  }


  .swiper-slide {
    background: transparent !important;
  }

  .swiper-button-next {
    position: absolute;
    top: 250px;
    right: 235px;
    width: 84px;
    height: 84px;
    border-radius: 50%;
    background-color: transparent;

  }


  #honourBanner .swiper-button-next {
    background: url(http://img.anxuan360.com/Fk93cBn2dpcku7E6A6QmeirWJu9G) no-repeat center 50% !important;
  }

  #honourBanner .swiper-button-next:hover {
    background-color: #2b3453 !important;
  }

  .swiper-button-next:hover {
    background-color: #2b3453;
  }

  .swiper-button-prev {
    position: absolute;
    top: 250px;
    left: 235px;
    width: 84px;
    height: 84px;
    border-radius: 50%;
    background-color: transparent;
  }

  .swiper-button-prev:hover {
    background-color: #2b3453;
  }

  .span1 {
    position: absolute;
    top: 18px;
    left: 135px;
    font-size: 14px;
    font-family: inpin heiti;
    font-weight: 400;
    color: #63686C
  }

  .span2 {
    position: absolute;
    top: 35px;
    left: 135px;
    font-size: 14px;
    font-family: inpin heiti;
    font-weight: 400;
    color: #63686C
  }

  .radius {
    width: 130px;
    height: 130px;
    display: block;
    margin: 0 auto;
    border-radius: 50%;
    margin-bottom: 20px;
    background-color: white;
    position: relative;
    box-shadow: 1px 2px 18px 0px rgba(160, 180, 179, 0.35);

  }

  .img1 {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;

  }

  .font2 {
    text-align: center;
    height: 19px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 600;
    color: #333333;
  }

  .font3 {
    color: white;
    font-size: 26px;
    margin-top: 36px;
    margin-left: 505px;
    font-family: Microsoft YaHei;
    font-weight: 400;

  }

  .font4 {
    color: white;
    font-size: 26px;
    margin-top: 36px;
    margin-left: 505px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    width: 821px
  }

  .font5 {
    width: 180px;
    height: 29px;
    font-size: 30px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #141414;
    margin-bottom: 36px;
  }

  .font6 {
    text-align: center;
    width: 432px;
    height: 17px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #141414;
  }

  .font7 {
    text-align: center;
    height: 23px;
    font-size: 22px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #202020;
    line-height: 32px;
    margin-bottom: 20px;
    margin-top: 30px;
  }

  .font8 {
    text-align: center;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 500;
    color: #202020;
    line-height: 24px;

  }

  .quan {
    position: relative;
  }

  .imgw {
    position: absolute;
    top: -60px;
    left: 300px;
  }

  .weizi1 {
    position: absolute;
    top: 120px;
    right: 400px
  }

  .imgz {
    position: absolute;
    top: 366px;
    right: 300px;
  }

  .img4 {
    width: 340px;
    height: 286px;
    background: #E7E7E7;
    opacity: 0.88;
  }

  .weizi2 {
    position: absolute;
    top: 575px;
    left: 450px;
  }

  .font1 {
    margin-top: 15px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #808080;
    text-align: center;
    width: 214px;
    height: 101px;
  }

  .body1 {
    display: flex;
    width: 821px;
    margin: 0 auto;
    justify-content: space-between;
    margin-top: -50px;

  }

  .body1>.both {
    width: 214px;
  }

  .background1 {
    background-image: url(../../static/img/img_bg_solution.png);
    width: 100%;
    height: 788px;
    position: relative;
    overflow: hidden;
  }

  .fanan {
    height: 36px;
    font-size: 36px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #FFFFFF;
    text-align: center;
    margin-top: 80px;
  }

  .left {
    position: absolute;
    left: 367px;
    top: 500px;
    width: 58px;
    height: 58px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;





  }

  .left:hover {
    background-color: #2b3453;
  }

  .right {
    position: absolute;
    right: 367px;
    top: 500px;
    width: 58px;
    height: 58px;

    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    cursor: pointer;
  }

  .right:hover {
    background-color: #2b3453;
  }

  .buju {
    display: flex;
    font-size: 18px;

    width: 1200px;
    margin: auto;
    margin-top: 35px;
  }

  .buju1 {
    display: flex;
    width: 1100px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;

  }


  .number1 {
    position: absolute;
    top: 236px;
    left: 1406px;
    font-size: 20px;
    color: #FFFFFF;
  }

  .buju>li {
    text-align: center;
    width: 400px;
    line-height: 50px;
    padding: 2px;
    font-size: 22px;
    border-bottom: 1px white solid;
    color: #B6B7C2;
  }

  .buju>.light1 {
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 42px;
    font-size: 24px;
    border-bottom: 5px white solid;
  }

  .img2 {

    display: block;
    margin: auto;
    margin-top: 66px;
  }

  .img3 {

    display: block;
    margin: auto;
    margin-top: 27px;
  }

  .p4 {
    width: 340px;
    height: 19px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #323233;
    text-align: center;

    margin-top: 25px;
  }

  .navBarWrap {
    position: fixed;
    top: 0px;
    z-index: 99999999999999999;
    background-color: #fff;
    width: 100%;
  }

  .focuImg {
    position: relative;
    overflow: hidden;
  }

  .focuImg .li {
    background-color: #668fe7;
    position: absolute;
    border-radius: .3rem;
    color: #fff;
    font-size: .08rem;
    font-weight: 500;
    padding: .06rem .2rem .06rem .2rem;
    transition: all 2s;
    opacity: 0;
  }

  .focuImg .li1.active {
    transform: translateX(0px);
    opacity: 1;
  }

  .focuImg .li2.active {
    transform: translateY(0px);
    opacity: 1;
  }

  .focuImg .li3.active {
    transform: translateX(0px);
    opacity: 1;
  }

  .focuImg .li1 {
    transform: translateX(-100px);
    width: .5rem;
    left: .75rem;
    bottom: .8rem;
  }

  .focuImg .li2 {
    transform: translateY(-100px);
    width: .75rem;
    right: 2.3rem;
    bottom: 1.38rem;
  }

  .focuImg .li3 {
    transform: translateX(100px);
    width: .65rem;
    right: 0.1rem;
    bottom: 1rem;
    z-index: 999999999999999999;
  }

  .swiper-container-horizontal>.swiper-pagination-bullets,
  .swiper-pagination-custom,
  .swiper-pagination-fraction {
    bottom: -40px;
  }

  .swiper-pagination-bullet {
    width: 10px;
    height: 10px;
    border-radius: 50%;
  }

  .swiper-pagination-bullet-active {
    background: #fff;
    width: 10px;
    height: 10px;
    border-radius: 50%;
  }
</style>
<style scoped>
  #home_dataShow .dataShow_box {
    width: 1500px;
  }

  .anli .iocBox li .bottomBox {
    position: absolute;
    bottom: 0;
    background-color: transparent !important;
    z-index: 0;
    height: 70px;
    line-height: 70px;
    padding-left: 19px;
  }

  .gnld4con {

    margin: 0 auto;
    flex-direction: row;
    justify-content: space-between;
  }

  .gnld4con {
    height: 41px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #202020;
    line-height: 24px;
    text-align: center;
  }

  .gnld4con:nth-child(1) {
    width: 120px
  }

  .gnld4con:nth-child(2) {
    width: 155px
  }

  .gnld4con:nth-child(3) {
    width: 190px
  }

  .anli .iocBox li {
    margin-bottom: 39px !important;
  }

  .company_infoContect .guanzhu {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    margin-bottom: 12px;
  }

  .company_infoContect .wxHao {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    margin-top: 10px;
  }

  .pc {
    padding-top: 67px;
  }

  html,
  body {
    position: relative;
    height: 100%;
  }

  body {
    background: #eee;
    font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
    font-size: 14px;
    color: #000;
    margin: 0;
    padding: 0;
  }

  .TopNav li.active {
  	border-bottom: 1px solid #00C59F;
  	font-size: 18px;
  	font-family: Microsoft YaHei;
  	font-weight: bold;
  	color: rgba(20, 20, 20, 1);

  }

  .TopNav {

  	display: flex;
    width: 100%;
    /* width: 1200px; */
    box-sizing: border-box;
    justify-content: center;
  	box-shadow: 0px 14px 13px 0px rgba(112, 112, 149, 0.06);
    margin-bottom: 10px;
  	/* padding-left: 450px; */
   /* float: right; */
  }

  .TopNav li {
   /* flex: 1;
      flex-grow: 1; */
    flex-shrink: 0;
  	cursor: pointer;
  	/* width: 120px; */
    padding:0 14px;
  	text-align: center;
  	margin: 0 30px;
  	height: 68px;
  	line-height: 68px;
  	display: inline-block;
  	font-size: 18px;
  	font-family: Microsoft YaHei;
  	font-weight: 400;
  	color: rgba(51, 51, 51, 1);
  }


  .gnld {
    /*padding-top: 83px;*/
    height: 517px;
    width: 1100px;
    margin: 0 auto;
    /*border:1px solid red;*/
  }

  .iocBox {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .iocBox li {
    position: relative;
    width: 100px;
    height: 100px;
    margin-right: 150px;
    margin-bottom: 60px;
  }

  .iocBox li:nth-child(5),
  .iocBox li:nth-child(10) {
    margin-right: 0px;
  }

  .iocBox li>img {
    width: 60px;
    height: 60px;
    display: block;
    margin: 0 auto;
  }

  .iocBox li>p {
    height: 18px;
    line-height: 18px;
    font-size: 18px;
    margin-top: 20px;
    text-align: center;
  }

  .yyhy {
    height: 900px;
    padding: 0px !important;
    padding-top: 150px !important;
    width: 100%;
    display: block;
  }

  .row {
    width: 1126px;
    margin: 0 auto;
    margin-top: 80px;
    display: flex;
  }

  .yyhyitem {
    background-image: url(../../static/img/yyhy_bg.png);
    width: 338px;
    height: 390px;
    margin-right: 56px;
  }

  .yyhyitem img {
    margin: 0 auto;
    padding-top: 75px;
  }

  .yyhyitem .t {
    margin-top: 43px;
    height: 25px;
    text-align: center;
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #3C444F;
    line-height: 22px;
  }

  .yyhyitem .con {
    margin: 0 auto;
    margin-top: 17px;
    width: 241px;
    height: 39px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #3C444F;
    line-height: 22px;
    text-align: center;
  }

  .dzfa {
    height: 586px;
    width: 100%;
    background-color: #FBFBFC;
    background-size: 100% 100%;
    display: block;
  }

  .cpdz {
    display: flex;
    margin: 0 auto;
    width: 1056px;
  }

  .cpdzitem {
    width: 186px;
    height: 312px;
    border: 4px dashed #535F6C;
    border-radius: 10px;
    margin-right: 23px;
  }

  .cpdzitem:last-child {
    margin-right: 0px;
  }

  .cpdzitem img {
    padding-top: 40px;
    margin: 0 auto
  }

  .cpdzitem .t {
    margin-top: 30px;
    height: 19px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    text-align: center;
    line-height: 19px;
  }

  .cpdzitem .con {
    width: 154px;
    height: 88px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #B4B7C0;
    margin: 0 auto;
    margin-top: 40px;
  }

  .shyy {
    height: 570px;
    background: #FBFBFC;
    display: block;
    /*opacity: 0.87;*/
  }

  #shyyflex {
    display: flex;
    margin: 0 auto;
    width: 1084px;
  }

  .shyyitem {
    width: 280px;
    margin-right: 122px;
  }

  .shyyitem:last-child {
    margin-right: 0px;
  }

  .shyyitem img {
    margin: 0 auto;
  }

  .shyyitem .t {
    margin-top: -40px;
    height: 18px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #323233;
    line-height: 18px;
    text-align: center;
  }

  .shyyitem .con {
    margin: 0 auto;
    width: 240px;
    margin-top: 22px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #808080;
    line-height: 34px;
    text-align: center;

  }

  .fz42 {
    font-size: .42rem !important;
  }

  .lftext {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: .04rem;
  }

  .dianhua {
    width: .3rem;
    font-size: .06rem;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: rgba(255, 255, 255, 1);
    text-align: center;
    margin: 0 auto;
    margin-top: .05rem;
  }

  .shijian {
    width: .45rem;
    font-size: .05rem;
    font-family: Microsoft YaHei;
    color: #fff;
    text-align: center;
  }

  .heng {
    width: .27rem;
    height: 1px;
    background-color: #fff;
    margin: .06rem auto;
  }

  .lftext>img {
    margin-right: .03rem;
  }

  .lftext>p {
    font-size: .04rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
  }

  .lf .yuan>img {
    margin: 0 auto;
    display: block;
    width: 74%;
  }

  .lf {
    width: .45rem;
    height: 1.16rem;
    background: linear-gradient(0deg, rgba(0, 184, 148, 1), rgba(0, 197, 159, 1));
    border-radius: .23rem .23rem 0px 0px;
    position: fixed;
    right: 0;
    top: 40%;
    padding: .06rem 0;
    box-sizing: border-box;
  }

  .lianxi {
    height: .92rem;
    display: flex;
    align-items: center;
    background: url('/static/img/img_contactus_bg.png') no-repeat;
    background-size: cover;
    justify-content: center;
  }

  .lianxi p {
    font-size: .11rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(254, 254, 254, 1);
    text-align: center;
  }

  .lianxi a {
    display: flex;
    width: .69rem;
    height: .18rem;
    line-height: .18rem;
    background: rgba(255, 255, 255, 1);
    border-radius: 1px;
    font-size: .05rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(73, 141, 255, 1);
    margin: 0 auto;
    display: flex;
    justify-content: center;
    margin-top: .12rem;
  }

  .gengduo {
    display: block;
    cursor: pointer;
    width: .56rem;
    height: .18rem;
    border: 1px solid rgba(0, 197, 159, 1);
    text-align: center;
    line-height: .18rem;
    font-size: .05rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(0, 197, 159, 1);
    margin: .2rem auto;
    margin-top: .1rem;
  }

  .gengduo:hover {
    color: #fff;
    background-color: rgba(0, 197, 159, 1);
  }

  .x {
    width: 1200px;
  }

  .mb45 {
    margin-bottom: .45rem;
  }

  .content1 {
    /*padding: .3rem;*/
    position: relative;
  }

  .content1 .mddw {
    position: absolute;
    top: -68px;
    width: 100%;
    height: 68px;
    left: 0;
    z-index: -1;
  }

  .mokuai .gengduo {
    margin-bottom: 0;
    background-color: rgba(0, 197, 159, 1);
    color: #fff;
  }

  .mokuai .gengduo img {
    display: inline-block;
    margin-left: .03rem;
  }

  .bjh {
    background: #F5F6F9;
  }

  .flexY {
    display: flex;
    align-items: center;
  }

  .logoTop .logo {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .logo>img {
    width: .45rem;
  }

  .logoTop {
    background-color: #fff;
    height: .3rem;
    padding-left: .11rem;
  }

  .logoR p {
    font-family: inpin heiti;
    font-size: .05rem;
  }

  .content1 {
    justify-content: center;
  }

  .imgTextBox {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .imgTextBox p {
    font-size: .08rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(50, 50, 51, 1);
    line-height: .16rem;
  }

  .pc .zuhe li {
    width: 1200px;
    height: 400px;
    background: rgba(255, 255, 255, 1);
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 30px;
  }

  .pc .zuhe li .zuheBox {
    display: flex;
    align-items: center;
  }

  .fbiaoti {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(50, 50, 51, 1);
    margin-top: 23px;
    text-align: center;
    margin-bottom: 100px;
  }

  .JJFA {
    width: 1050px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
  }

  .topxian {
    width: 74px;
    height: 1px;
    background: #C8C7D8;
    margin-bottom: 15px;
    margin-top: 50px;
  }

  .JJFA .l .pTop {
    font-size: 30px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(48, 143, 255, 1);
    margin-bottom: 15px;
  }

  .JJFA .l {
    width: 340px;
  }

  .JJFA .l .Plist {
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(50, 50, 51, 1);
    position: relative;
    padding-left: 20px;
    line-height: 35px;
    margin-bottom: 49px;
  }

  .JJFA .l .Plist:before {
    content: "";
    position: absolute;
    left: 0;
    top: 10px;
    width: 8px;
    height: 16px;
    background: rgba(48, 143, 255, 1);
    border-radius: 4px;
  }

  .pc .zuhe li .zuheBox .rtext {
    margin-left: 144px;
  }

  .pc .zuhe li .zuheBox .rtext .tdNav {
    margin-top: 46px;
    display: flex;
  }

  .pc .zuhe li .zuheBox .rtext .tdNav>div {
    width: 80px;
    margin-right: 36px;
  }

  .pc .zuhe li .zuheBox .rtext .tdNav>div:last-child {
    margin-right: 0;
  }

  .pc .zuhe li .zuheBox .rtext .tdNav img {
    width: 80px;
    height: 80px;
  }

  .pc .zuhe li .zuheBox .rtext .tdNav p {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    text-align: center;
    margin-top: 24px;
  }

  .pc .zuhe li .zuheBox .rtext p:nth-child(1) {
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: rgba(44, 58, 70, 1);
  }

  .pc .zuhe li .zuheBox .rtext p:nth-child(2) {
    margin-top: 18px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(44, 58, 70, 1);
  }

  .pc .zuhe li .zuheBox>div>img {
    width: 224px;
    height: 298px;
  }

  .pc .zuhe li .rioc {
    box-sizing: border-box;
    position: absolute;
    right: 20px;
    top: 20px;
    width: 122px;
    height: 42px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 5px 14px 4px rgba(91, 140, 223, 0.09);
    border-radius: 21px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 20px;
    padding-right: 5px;
  }

  .pc .zuhe li .rioc span {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    line-height: 42px;
  }

  .pc .zuhe li:nth-child(1) .rioc span {
    color: #5AA6FF;
  }

  .pc .zuhe li:nth-child(2) .rioc span {
    color: #5BCA54;
  }

  .pc .zuhe li:nth-child(3) .rioc span {
    color: #948FFF;
  }

  .pc .zuhe li .rioc img {
    width: 36px;
    height: 36px;
    margin: 0;
  }

  .imgTextBox>div:first-child {
    margin-right: .39rem;
    width: 3.3rem;
  }

  .imgTextBox>div:first-child>img {
    width: 100%;
  }

  .yd .anli .iocBox li .bottomBox {
    width: 100%;
    height: 1.3rem;
    border: 0px solid #fff;
    background-color: #fff;
    display: flex;
    align-items: center;
    padding-left: .38rem;
    box-sizing: border-box;
  }

  .anli .iocBox li .bottomBox {
    width: 100%;
    height: .3rem;
    background-color: #fff;
    display: flex;
    align-items: center;
    box-sizing: border-box;
  }

  .anli .iocBox li .bottomBox p {
    margin-top: 0;
    height: .15rem;
    background-size: 100% 100%;
    font-size: .06rem;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: rgba(255, 255, 255, 1);
    line-height: .15rem;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(20, 20, 20, 1);
  }

  .yd .anli .iocBox li .bottomBox p {
    margin-top: 0;
    height: .5rem;
    background: url('/static/img/img_case_name_bg_8.png') center no-repeat;
    background-size: 100% 100%;
    font-size: .28rem;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: rgba(255, 255, 255, 1);
    line-height: .5rem;
    padding: 0 .2rem;
    color: #fff;
  }

  .fuwu li {
    width: 230px;
    text-align: center;
  }

  .fuwu li p {
    margin-top: 0;
  }

  .fuwu li .p1 {
    font-size: 22px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(32, 32, 32, 1);
    margin-top: 21px;
    margin-bottom: 33px;
  }

  .fuwu li .p2 {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(32, 32, 32, 1);
    line-height: 25px;
  }

  .biaoti {
    /*font-size: .14rem;*/
    font-size: 36px!important;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(50, 50, 51, 1);
    margin-bottom: .29rem;
    text-align: center;
    font-weight: bold;
  }

  .biaoti1 {
    height: 20px;
    font-size: 20px;
    line-height: 20px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #767676;
    text-align: center;
  }

  .biaoti2 {
    margin-top: 60px;
    width: 100%;
    height: 31px;
    font-size: 30px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000201;
    line-height: 32px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/cyqy.vue